<template>
    <v-card class="project-card"
            :class="{'project-card--wide-padding' : selectedCommunities.length}">
        <slot v-if="tab" name="filters">{{analysisLabel}}</slot>
        <v-card-text v-if="!tab" class="project-card__filter-row">
            <div v-if="selectedCommunities.length" class="filter__communities">
                <ProjectFiltersCommunityItem
                        :project="project"
                        :is_temporary="community.is_temporary"
                        v-for="(community, index) in selectedCommunities"
                        :key="index"
                        :community="community"
                        :communitiesAmount="selectedCommunities.length"
                ></ProjectFiltersCommunityItem>
            </div>
            <ProjectOverviewAddCommunity v-if="selectedCommunities.length < 3"
                    :selectedCommunities="selectedCommunities"
                    :isEmpty="selectedCommunities.length"
                    :isDialogOpened="isDialogOpened"
                    :isActive="selectedCommunities.length < 3"
            ></ProjectOverviewAddCommunity>
        </v-card-text>
        <v-card-actions v-if="selectedCommunities.length" class="project-card__filter-row">
            <div class="date-time-picker">
                <p class="data-time-picker__text">Between:</p>
                <DateTimePicker
                        v-if="project.timeframe_start"
                        :initialDate="project.timeframe_start"
                        v-model="timeframe_start"
                        :isValid="true"
                ></DateTimePicker>
                <p class="data-time-picker__text">and</p>
                <DateTimePicker
                        v-if="project.timeframe_end"
                        :initialDate="project.timeframe_end"
                        v-model="timeframe_end"
                        :isValid="isEndValid"
                ></DateTimePicker>
            </div>
        </v-card-actions>
        <div v-if="!isEndValid" class="error-message">{{errMessage}}</div>
    </v-card>
</template>

<script>
    import moment from 'moment'
    import ProjectOverviewAddCommunity from "./ProjectAddCommunity";
    import ProjectFiltersCommunityItem from "./ProjectFiltersCommunityItem";
    import DateTimePicker from "../../../DateTimePicker";
    import {errorMessageHandler} from "../../../../_utils/errorMessageHandler";
    import {store} from "../../../../store/store";

    export default {
        name: "ProjectOverviewFilters",
        components: {DateTimePicker, ProjectFiltersCommunityItem, ProjectOverviewAddCommunity},
        props: ['isDialogOpened', 'selectedCommunities', 'project',
            'tab', 'analysisLabel'],
        data: () => ({
            timeframe_start: null,
            timeframe_end: null,
            isEndValid: true,
            errMessage: '',
            startDate: null,
            endDate: null,
            dialog: null
        }),
        methods: {
            updateProjectTimeframe(type, val) {
                var update_args = {};
                update_args[type] = val;

                var config = {
                  projectId: this.project.id,
                  partial: update_args,
                }
                store.dispatch('updateProject', config)
                    .then(resp => {
                        this.$emit('input', resp);
                        this.isEndValid = true;
                    }).catch(err => {
                      var errResp = err.response
                      if (errResp) {
                          if (errorMessageHandler(errResp.data.error, errResp.status)) {
                              this.errMessage = errorMessageHandler(errResp.data.error, errResp.status);
                              this.isEndValid = false;
                          }
                      }
                })
            },
            formatDate(date) {
                const validDateArr = date.split('/');
                [validDateArr[0], validDateArr[1]] = [validDateArr[1], validDateArr[0]];
                const validDate = validDateArr.join('-');
                console.log("ProjectOvervewFilters formatDate validDate=", validDate)
                return moment(validDate, "MM-DD-YYYY HH:mm").toISOString();
            },
        },
          watch: {
            timeframe_start: {
                handler: function (val) {
                    if (val != this.timeframe_end) {
                        this.updateProjectTimeframe("timeframe_start", this.formatDate(val))
                    }
                },
                deep: true
            },
            timeframe_end: {
                handler: function (val) {
                    if (val != this.timeframe_start) {
                        this.updateProjectTimeframe("timeframe_end", this.formatDate(val))
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
